import * as faceapi from "face-api.js";

// Carga de modelos face-api con resiliencia:
// 1) intenta el bundle local /models (con reintentos),
// 2) si falla (p.ej. el servidor de producción no sirve /models correctamente),
//    cae a un CDN público con los mismos pesos.
const LOCAL_URI = "/models";
const CDN_URI = "https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@master/weights";

async function _loadFrom(uri) {
  await faceapi.nets.tinyFaceDetector.loadFromUri(uri);
  await faceapi.nets.faceLandmark68TinyNet.loadFromUri(uri);
  await faceapi.nets.faceRecognitionNet.loadFromUri(uri);
}

let _loaded = false;

/** Carga los 3 modelos necesarios. Lanza el último error si local y CDN fallan. */
export async function loadFaceModels(localAttempts = 2) {
  if (_loaded) return;
  let lastErr;
  // Intentos locales
  for (let i = 0; i < localAttempts; i++) {
    try {
      await _loadFrom(LOCAL_URI);
      _loaded = true;
      return;
    } catch (err) {
      lastErr = err;
      if (i < localAttempts - 1) await new Promise((r) => setTimeout(r, 700 * (i + 1)));
    }
  }
  // Fallback a CDN
  try {
    await _loadFrom(CDN_URI);
    _loaded = true;
    return;
  } catch (err) {
    lastErr = err;
  }
  throw lastErr;
}
